import { Rgba, Hsv, ColourUtils } from './ColourUtils';
export class Colour {
    private _hsv : Hsv = {h:0, s:0, v:1};
    private _rgba: Rgba = {r:0, g:0, b:0, a:1}

    constructor(hsv: Hsv){
        this.setHsv(hsv);
    }

    getHsv(): Hsv{
        return this._hsv;
    }
    getRgba(): Rgba{
        return this._rgba;
    }
    getColor(): string{
        return ColourUtils.rgbaToString(this._rgba); 
    }
    getColorWithAlpha(alpha:number){
        var rgba = {r:this._rgba.r, g:this._rgba.g, b:this._rgba.b, a:alpha};
        return ColourUtils.rgbaToString(rgba);
    }

    setHsv(val: Hsv){
        if(val){
            this._hsv = val;
            this._rgba = ColourUtils.hsvToRgba(this._hsv);
            //this.print()
        }
    }

    print(){
        console.log(this.toString())
    }

    toString(): string{
        return "color, hsv:["+this._hsv.h+","+this._hsv.s+","+this._hsv.v+"] rgba:["+this._rgba.r+","+this._rgba.g+","+this._rgba.b+","+this._rgba.a+"]";
    }

    setHsvRgba(hsv:Hsv, rgba: Rgba){
        if(hsv){
            this._hsv = hsv;
        }
        if(rgba){
            this._rgba = rgba;
        }
    }
}
/*export abstract class Colourable{
    private _colors: Array<Color> = [];

    protected init(count: number){
        this._colors = new Array<Color>(count);
    }

    protected addColor(col: Color){
        this._colors.push(col);
    }

    getColor(index: number): Color{
        if(index < this._colors.length){
            return this._colors[index];
        }
        return new Color();
    }

    getColorCount(): number{
        return this._colors.length;
    }

    isColourable(): boolean{
        return true;
    }
}*/